module.exports = __webpack_public_path__ + "static/media/Campaign.e1481aa8.png";